import InitialLoad from './InitialLoad';

export default InitialLoad;
